<template>
  <div class="upload-file">
    <template v-if="currentImage">
      <div
        class="text-xs-center preview-img"
        style="
          overflow: hidden;
          min-height: 150px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        "
        :style="{
          'min-height': height + 'px',
          'background-image': 'url(\'' + showImage + '\')',
          'border-top-right-radius': borderTopRightRadius + 'px',
          'border-top-left-radius': borderTopLeftRadius + 'px',
        }"
      >
        <template v-if="loading">
          <div
            style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
            :style="{
              'border-top-right-radius': borderTopRightRadius + 'px',
              'border-top-left-radius': borderTopLeftRadius + 'px',
            }"
          >
            <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
          </div>
        </template>
        <div v-else class="overlay">
          <div
            v-if="changeRatio"
            style="display: flex; position: absolute; right: 0; padding: 8px"
            @click="convertImageRatio"
          >
            <img src="/static/img/SwitchRatio.png" style="width: 25px; height: 25px" />
          </div>
          <v-layout
            justify-center
            fill-height
            align-center
            row
            class="mb-0"
            style="min-height: 100%"
            :style="{ 'min-height': height + 'px' }"
          >
            <div @click="onClickUploadButton">
              <slot>
                <v-btn small depressed color="primary" style="font-size: 11px">
                  <span class="fa fa-camera mr-1"></span>
                  {{ $t('select file to upload') }}
                </v-btn>

                <div class="caption text-xs-center" style="color: white">
                  {{ $t('upload file size: {size}MB', { size: 5 }) }}
                </div>
                <div v-if="changeRatio" class="caption text-xs-center" style="color: white">
                  {{ $t(`recommended ratio ${ratio}` ) }}
                </div>
              </slot>
            </div>
          </v-layout>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="text-xs-center"
        :style="{
          'border-top-right-radius': borderTopRightRadius + 'px',
          'border-top-left-radius': borderTopLeftRadius + 'px',
        }"
      >
        <div
          style="min-height: 150px; background: #eee; overflow: hidden; position: relative"
          :style="{
            'min-height': height + 'px',
            'border-top-right-radius': borderTopRightRadius + 'px',
            'border-top-left-radius': borderTopLeftRadius + 'px',
          }"
        >
          <template v-if="loading">
            <div
              style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
            >
              <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
            </div>
          </template>
          <template v-else>
            <v-layout
              justify-center
              fill-height
              align-center
              row
              class="mb-0"
              style="min-height: 100%"
              :style="{ 'min-height': height + 'px' }"
            >
              <div @click="onClickUploadButton">
                <slot>
                  <v-btn small depressed color="primary" style="font-size: 11px">
                    <span class="fa fa-camera mr-1"></span>
                    {{ $t('อัปโหลดรูป') }}
                  </v-btn>

                  <div class="caption grey--text text-xs-center">
                    {{ $t('upload file size: {size}MB', { size: 10 }) }}
                  </div>
                </slot>
              </div>
            </v-layout>
          </template>
        </div>
      </div>
    </template>
    <input
      type="file"
      class="form-control-file pt-2"
      name="photoUpload"
      :id="'photoUploadInput' + objId"
      data-vv-as="File"
      v-validate="'image|size:10240|mimes:image/jpeg,image/png,image/jpg,image/gif'"
      accept=".jpg, .png, .jpeg, .gif"
      :multiple="multiple"
      @change="onFileChange($event)"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
    />
  </div>
</template>
<script>
import UploadSingleFile from './UploadSingleFile.js'
export default {
  mixins: [UploadSingleFile],
}
</script>



// WEBPACK FOOTER //
// src/components/elements/uploadfile.vue